module.exports = {
          srcSet: __webpack_public_path__ + "65ce65f6.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "65ce65f6.png",width: 60,height: 53}],
          src: __webpack_public_path__ + "65ce65f6.png",
          toString:function(){return __webpack_public_path__ + "65ce65f6.png"},
          
          width: 60,
          height: 53
        }